import { ModelBase } from '@framework/models/base/base.model';
import { UserContextModel } from '../../auth-models';

export class LoginMicrosoftOutputApiModel extends ModelBase{
    public userContext: UserContextModel;
    constructor(init?: Partial<LoginMicrosoftOutputApiModel>){
        super(init);
        Object.assign(this, init);
    }
}